module.exports = __webpack_public_path__ + "img/20190529162052431.37320cd6.png";